import Cookies from "js-cookie";

const AUTH_COOKIE_NAME = 'token';
const PRODUCTION_COOKIE_DOMAIN = 'kvartiranasutki.com';

function getAuthCookieDomain() {
    const domain = window.location.protocol === 'https:'
        ? process.env.REACT_APP_DOMAIN
        : process.env.REACT_APP_LOCAL_DOMAIN;

    return domain?.replace(/^\./, '') || null;
}

function getCookieTokenValues() {
    return document.cookie
        .split('; ')
        .filter((cookie) => cookie.startsWith(`${AUTH_COOKIE_NAME}=`))
        .map((cookie) => {
            const value = cookie.slice(AUTH_COOKIE_NAME.length + 1);
            try {
                return decodeURIComponent(value);
            } catch {
                return value;
            }
        });
}

function removeLegacyCookieVariants() {
    const domain = getAuthCookieDomain();

    if (domain && window.location.hostname !== domain) {
        Cookies.remove(AUTH_COOKIE_NAME, { path: '/' });
    }

    if (domain === 'staging.kvartiranasutki.com') {
        Cookies.remove(AUTH_COOKIE_NAME, { path: '/', domain: `.${PRODUCTION_COOKIE_DOMAIN}` });
    }
}

export function getAuthToken() {
    return Cookies.get(AUTH_COOKIE_NAME);
}

export function confirmAuthCookie(expectedToken) {
    if (!getCookieTokenValues().includes(expectedToken)) {
        throw new Error('Browser rejected the authentication cookie');
    }

    removeLegacyCookieVariants();

    if (getAuthToken() !== expectedToken) {
        throw new Error('Authentication cookie is out of sync');
    }
}

export function clearAuthCookies() {
    removeLegacyCookieVariants();

    const domain = getAuthCookieDomain();
    Cookies.remove(AUTH_COOKIE_NAME, {
        path: '/',
        ...(domain ? { domain: `.${domain}` } : {}),
    });
}
